import { gql } from "@apollo/client";

export const EDIT_CCPA = gql`
  mutation Mutation($ccpaPrivacyPreference: Boolean) {
    editProfile(ccpaPrivacyPreference: $ccpaPrivacyPreference)
  }
`;
